export const NEXT_EPISODE_DURATION = 10;
